import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import _get from 'lodash.get';
import { checkJarvisIsAdActive } from 'helpers/ads/utils';
import AdCaller from 'helpers/ads/adCaller';
import makeRequest from 'utils/makeRequest';
import Link from 'components/Link';
import Image from 'components/Image';
import adBlockPromise from 'components_v2/common/AdBlockerDetector/AdBlockDetectUtils';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { debounce } from 'utils/common';
import { showOpenInApp } from '../../../routes/liveblog_v2/redux';
import s from './AdCube.scss';

class AdCube extends React.Component {
  constructor(props) {
    super(props);
    this.cubeRef = React.createRef();

    this.state = {
      mounted: undefined,
      rotatersCss: {},
      wrapperCss: {},
      innerCSS: {},
      cardsCss: {},
      enable: false,
      showCubeFlag: true,
    };
    this.debouncedHandleScroll = debounce(this.handleScroll.bind(this), 10);

    this.numOfItems = undefined;
    this.angle = undefined;
    this.currentAngle = 0;
    this.rotating = false;
    this._const = {
      HRS_IN_DAY: 24,
      MINS_IN_HR: 60,
      SEC_IN_MIN: 60,
      MILLISEC_IN_SEC: 1000,
      storageName: 'cubeClosed',
      wait_duration: 4000,
    };
    this.axis = this.props.xRotation ? 'Y' : 'X';
    this.angleMult = this.props.xRotation ? 1 : -1;
    this.timer = false;
  }

  fetchData = url => {
    makeRequest
      .get(url, {}, 'skipfeedengine')
      .catch(err => console.log(err))
      .then(data => {
        if (data && data.status === 200 && data.data?.cards) {
          this.data = data.data;
          this.cards = this.data.cards;
          this.setState({ enable: true });
          setTimeout(this.initSlider(), 250);
          this.props.showOpenInApp(false);
        } else {
          this.disableCubeFor();
        }
      });
  };

  disableCubeFor = () => {
    const hours = 1 / 12; // SET FOR 5 MIN SO NEXT TIME IT WONT CALL.
    this.setExpiryTime(hours);
  };

  renderCube = data => {
    const currentTime = new Date().getTime();
    try {
      const expiryTime = sessionStorage.getItem(this._const.storageName);
      if ((expiryTime && expiryTime < currentTime) || !expiryTime) {
        let url = '';
        url = `/react_cube_config/feedtype-sjson${
          this.props.isWapView ? ',ismobile-true' : ''
        }${
          this.props.channel === 'etimes' ? ',business-etimes' : ''
        }.cms?cubeId=${data?.cubeId}&msid=${data?.msid}&isNewGam=${
          this.props.isNewGam
        }`;
        this.fetchData(url);
      }
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    adBlockPromise.then(isAdBlockOn => {
      if (!isAdBlockOn) {
        const jarvisSetting = checkJarvisIsAdActive('cube');
        if (jarvisSetting) {
          if (window.location.pathname === '/') {
            this.setState(
              {
                showCubeFlag: false,
              },
              () => {
                window.addEventListener('scroll', this.debouncedHandleScroll);
                this.renderCube(jarvisSetting);
              },
            );
          } else {
            this.renderCube(jarvisSetting);
          }
        }
      }
    });
    // adBlockPromise.then(isAdBlockOn => {
    //   if (!isAdBlockOn) {
    //     this.renderCube();
    //   }
    // });
  }
  handleScroll() {
    this.setState(
      {
        showCubeFlag: true,
      },
      this.initSlider(),
    );
    window.removeEventListener('scroll', this.debouncedHandleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.debouncedHandleScroll);
  }

  flipCube = () => {
    if (this.timer) {
      clearInterval(this.timer);
    }
    const waitDuration = this.data.wait_duration
      ? this.data.wait_duration
      : this._const.wait_duration;
    this.timer = setInterval(() => {
      if (!this.rotating) {
        this.navigateDown();
      }
    }, waitDuration);
  };

  clearFlipCube = () => {
    if (this.timer) {
      clearInterval(this.timer);
    }
  };

  rotateSlider = delta => {
    this.rotating = true;
    const newAngle = this.currentAngle + delta * this.angle;

    const rotatersCss = {
      transform: `rotate${this.axis}(${newAngle * this.angleMult * -1}deg)`,
      transition: `transform ${this.props.speed / 1000}s ${this.props.easing}`,
    };

    this.setState({
      rotatersCss,
    });

    this.currentAngle = newAngle;
    setTimeout(() => {
      const css = { ...rotatersCss };
      css.transition = 'transform 0s';
      this.setState({
        rotatersCss: css,
      });
      this.rotating = false;
    }, this.props.speed);
  };

  navigateUp = () => {
    this.rotateSlider(-1);
  };

  navigateDown = () => {
    this.rotateSlider(1);
  };

  initSlider = () => {
    const slider = this.cubeRef.current;

    if (!slider) {
      return;
    }

    this.numOfItems = this.cards.length;
    this.angle = 360 / this.numOfItems;
    const sDimension = this.props.xRotation
      ? slider.offsetWidth
      : slider.offsetHeight;
    const pers = sDimension * this.props.persMult;
    const depth = sDimension / 2 / Math.tan(this.angle / 2 * Math.PI / 180);

    const wrapperCss = {
      '-webkit-perspective': `${pers}px`,
      perspective: `${pers}px`,
    };

    const innerCSS = {
      transform: `translateZ(-${depth}px)`,
    };

    const cardsCss = this.cards.map((item, index) => ({
      transform: `rotate${this.axis}(${index *
        this.angle *
        this.angleMult}deg) translateZ(${depth}px)`,
    }));

    this.setState({
      mounted: true,
      wrapperCss,
      innerCSS,
      cardsCss,
    });

    document.getElementsByTagName('body')[0].classList.add('showcube');

    this.flipCube();
  };

  setExpiryTime = hours => {
    const MILLISEC_IN_HRS =
      this._const.MINS_IN_HR *
      this._const.SEC_IN_MIN *
      this._const.MILLISEC_IN_SEC;
    const expiryTime = new Date().getTime() + hours * MILLISEC_IN_HRS;
    try {
      sessionStorage.setItem(this._const.storageName, expiryTime);
    } catch (e) {
      console.log(e);
    }
  };

  clsBtnHandler = () => {
    const hours = this.data.fcap_hours
      ? parseInt(this.data.fcap_hours, 10)
      : 24;
    this.setState({ mounted: false });
    this.setExpiryTime(hours);
    const ga = {
      gaCategory: 'cross_cube',
      gaAction: window.location.href,
      gaLabel: '',
    };
    this.fireGA(ga);
    this.props.showOpenInApp(true);

    document.getElementsByTagName('body')[0].classList.remove('showcube');
  };

  renderAd = card => {
    const deviceType = this.props.isWapView ? 'mobile' : 'all';
    return (
      <AdCaller data={card.adData} deviceType={deviceType} immediateLoad />
    );
  };
  openAppHandler = data => {
    if (data) {
      const ele = data.split(',');
      const ga = {
        gaCategory: ele[0],
        gaAction: ele[1],
        gaLabel: ele[2],
      };
      this.fireGA(ga);
    }
  };
  fireGA = data => {
    if (data) {
      sendGaThroughProps({ data });
    }
  };

  renderNews = card => (
    <div className={s.cube_news}>
      <h4>
        <i className={s.svg} /> news
      </h4>

      <div className={s.news_item}>
        <Link to={card.url} data={card.ga} target="_blank">
          {card.title}
        </Link>
      </div>
    </div>
  );

  renderContent = card => {
    // News
    if (card && typeof card.isNews !== 'undefined') {
      return this.renderNews(card);
    }
    if (card && typeof card.iframe !== 'undefined') {
      return this.renderIframe(card);
    }
    if (card && typeof card.adData !== 'undefined') {
      return this.renderAd(card);
    }

    if (card && typeof card.branding !== 'undefined') {
      return this.renderBranding(card);
    }
    if (card && typeof card.openinapp !== 'undefined') {
      return this.renderOpeninapp(card);
    }
    if (
      card &&
      typeof card.title !== 'undefined' &&
      typeof card.url !== 'undefined' &&
      typeof card.img !== 'undefined'
    ) {
      return this.renderBanner(card);
    }

    return null;
  };

  renderBranding = card => <div className={s.branding}>{card.title}</div>;
  renderOpeninapp = card => (
    <div className={s.openinapp}>
      {' '}
      <Link
        to={card.link}
        target="_blank"
        onClick={() => this.openAppHandler(card.ga)}
      >
        {card.title}
      </Link>
    </div>
  );

  renderBanner = card => (
    <Link to={card.url} data={card.ga} target="_blank">
      <Image
        title={card.title}
        caption={card.title}
        altTitle={card.title}
        src={card.img}
      />
    </Link>
  );
  renderIframe = card => (
    <iframe
      frameBorder="0"
      width="100%"
      height="100%"
      title={card.title}
      src={card.url}
    />
  );
  getCards = (cards, cardsCss) => {
    const listCards = cards.map((card, index) => (
      <div className={s.slider3d__item} style={cardsCss[index]}>
        <button
          type="button"
          className={s.cls_btn}
          onClick={this.clsBtnHandler}
          aria-label="top right align"
        />
        {card.header && (
          <div className={s.cube_header}>{this.renderContent(card.header)}</div>
        )}
        {card.content && (
          <div className={s.cube_content}>
            {this.renderContent(card.content)}
          </div>
        )}
        {card.footer && (
          <div className={s.cube_footer}>{this.renderContent(card.footer)}</div>
        )}
      </div>
    ));
    return listCards;
  };

  checkIfRenderNotRequired = () => {
    if (
      (typeof this.state.mounted === 'boolean' &&
        this.state.mounted === false) ||
      !this.state.enable ||
      (typeof window !== 'undefined' &&
        window.TimesApps &&
        window.TimesApps.PopUpManager &&
        window.TimesApps.PopUpManager.isPopuMangerRunning())
    ) {
      return true;
    }
    return false;
  };

  render() {
    const { isWapView, skipCube } = this.props;

    if (skipCube) return null;
    // mountd === false will remove cube.
    if (this.checkIfRenderNotRequired()) {
      return null;
    }

    const { rotatersCss, wrapperCss, innerCSS, cardsCss } = this.state;
    const isFooterPresent = _get(this.cards, '[0].footer', false);
    const wrapperClassname = classnames({
      [`${s.slider3d}`]: true,
      [`${s.mobile}`]: isWapView,
      [`${s.footer}`]: isFooterPresent,
      [`${s['slider-ready']}`]: this.state.mounted,
      [s.shiftUp]: !this.props.isMobile && this.props.popUpVisble,
    });
    const containerClasses = classnames({
      [`${s.container}`]: true,
      [`${s.mobile}`]: isWapView,
    });

    return (
      <>
        <div
          className={`${this.props.popUpVisble ? s.PopupUpVisible : ''} ${
            s.toi_cube
          }`}
        >
          <div
            className={`${s.innerContainer} ${
              this.state.showCubeFlag ? s.show : s.hide
            }`}
          >
            <div className={containerClasses} ref={this.cubeRef}>
              <div className={wrapperClassname}>
                <div className={s.slider3d__wrapper} style={wrapperCss}>
                  <div className={s.slider3d__inner} style={innerCSS}>
                    <div className={s.slider3d__rotater} style={rotatersCss}>
                      {this.getCards(this.cards, cardsCss)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  popUpVisble: state.WithPopup && state.WithPopup.isVisible,
  isMobile: state.isMobile,
  isNewGam: _get(state, 'revenue.data.widgets.isNewGam', false),
  skipCube: _get(state, 'revenue.data.widgets.skipCube', false),
});

const mapDispatchToProps = dispatch => ({
  showOpenInApp: params => {
    dispatch(showOpenInApp(params));
  },
});

AdCube.propTypes = {
  xRotation: PropTypes.bool,
  speed: PropTypes.number,
  easing: PropTypes.string,
  persMult: PropTypes.number,
  isWapView: PropTypes.bool,
  popUpVisble: PropTypes.bool,
  isMobile: PropTypes.bool,
  isNewGam: PropTypes.bool,
  channel: PropTypes.string,
  skipCube: PropTypes.bool,
};
AdCube.defaultProps = {
  xRotation: true,
  speed: 1100,
  easing: 'ease',
  persMult: 1.6,
  isWapView: false,
  popUpVisble: false,
  isMobile: false,
  isNewGam: false,
  channel: '',
  skipCube: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdCube);
